import { render, staticRenderFns } from "./diseaseDialog.vue?vue&type=template&id=69acf50e&scoped=true&"
import script from "./diseaseDialog.vue?vue&type=script&lang=js&"
export * from "./diseaseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69acf50e",
  null
  
)

export default component.exports